<template>
<div>
  <div id="premium-level">
    <div id="profilepic" class="mediumShadow" style="grid-column: 1/2; grid-row: 1/2"
         :style="{ backgroundImage: 'url(' + profile.picture + ')'}">
      <div>
        <div v-if="profile.datas.is_premium" id="premiumIconProgression" class="flexwrap centercenter">
          <i class="fas fa-burn"></i>
        </div>
      </div>
    </div>
    <div class="softTextShadow"  style="grid-column: 2/3; grid-row: 1/2; text-decoration: none; ">
      <h1 :key="mainLevel">Niveau {{mainLevel+1}}
        <!--<animated-number :number="mainLevel+1"></animated-number>-->
      </h1>
      <progress-bar-step  :key="percentsCompleted" :value="percentsCompleted*1000" class="standardTheme"
                          :withoutColor="true"
      ></progress-bar-step>
      <span class="softTextShadow" :key="pointToLevelUp" style="font-size: 1.2em">
              <!--<animated-number :number="pointToLevelUp"></animated-number>-->
              {{pointToLevelUp}}pts pour le suivant</span>
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
name: "member-level",

  components: {
    progressBarStep: () => import(/* webpackPrefetch: true */ '@/components/progressBarStep.vue'),

  },

  computed: {
    ...mapGetters('global', [
        'isMobile', 'profile'
    ]),
    mainLevel:function(){
      if (this.profile.datas.points != null){
        return Math.floor(-10+Math.sqrt((this.profile.datas.points+5)+500)/Math.sqrt(5))
      }
      else {
        return 0
      }
    },
    percentsCompleted:function(){
      return 1-(this.pointToLevelUp / (Math.floor(5*Math.pow((this.mainLevel+1),2)+100*(this.mainLevel+1))-Math.floor(5*Math.pow(this.mainLevel,2)+100*this.mainLevel)))
    },
    pointToLevelUp:function(){
      if (this.profile.datas.points != null){
        return Math.floor(5*Math.pow((this.mainLevel+1),2)+100*(this.mainLevel+1)) - this.profile.datas.points-5
      }
      else {
        return 100
      }
    },
  }
}
</script>

<style scoped>
#premium-level {
  display: flex;
  flex-direction: row;
  align-items: center;
}

#profilepic {
  position: relative;
  width: 4.5vw;
  height: 4.5vw;
  border-radius: 5vw;
  /*border: #6A3805 0.1vw solid;*/
  background-position: center;
  background-size: contain;
  border: 0.2vw hsl(200, 20%, 10%) solid;
}

#premiumIconProgression{
  position: absolute;
  right: -0.1vw;
  top: -0.1vw;
  border-radius: 1.4vw;
  height: 1.4vw;
  width: 1.4vw;
  font-size: 0.8em;
  color: #ffda7b;
  background-color: hsl(200, 20%, 10%);
  margin-right: -2px;
}
</style>